import {Map, List} from 'immutable';

import {
    CITY_LIST_REQUEST,
    CITY_LIST_SUCCESS,
    CITY_LIST_FAILURE,
    CITY_READ_REQUEST,
    CITY_READ_SUCCESS,
    CITY_READ_FAILURE,
    CITY_UPDATE_REQUEST,
    CITY_UPDATE_SUCCESS,
    CITY_UPDATE_FAILURE,
    CITY_CREATE_REQUEST,
    CITY_CREATE_SUCCESS,
    CITY_CREATE_FAILURE,
    CITY_DELETE_REQUEST,
    CITY_DELETE_SUCCESS,
    CITY_DELETE_FAILURE,
    CITY_FORM_DESTROY
  } from './actions';
  import Logger from '../../../lib/Logger';
  
export default function cities(
    state=Map({
      areCitiesLoading: false
    }),
    action
  ) {
    Logger.log('debug', `[city.reducers] cities(%j, %j)`, state, action);
  
    switch(action.type) {
  
      case CITY_LIST_REQUEST:
        return state.mergeDeep({
          areCitiesLoading: true
        });
  
      case CITY_LIST_SUCCESS:
        return state.mergeDeep({
          areCitiesLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null
              }
            }
          },
          total: action.total,
          lastUpdated: action.receivedAt
        }).setIn(['pages', action.order, action.limit, action.page], List(action.result));
  
      case CITY_LIST_FAILURE:
        return state.mergeDeep({
          areCitiesLoading: false
        });
      case CITY_READ_REQUEST:
        return state.mergeDeep({
          areCitiesLoading: true
        });
  
      case CITY_READ_SUCCESS:
        return state.mergeDeep({
          areCitiesLoading: false,
          lastUpdated: action.receivedAt
        });
  
      case CITY_READ_FAILURE:
        return state.mergeDeep({
          areCitiesLoading: false
        });
        case CITY_UPDATE_REQUEST:
          return state.mergeDeep({
            areCitiesLoading: true,
            form: {
              isSubmitting: true,
              success: null,
              errors: null
            }
          });
    
        case CITY_UPDATE_SUCCESS:
          return state.mergeDeep({
            areCitiesLoading: false,
            form: {
              isSubmitting: false,
              success: true,
              errors: null
            },
            lastUpdated: action.receivedAt
          });
    
        case CITY_UPDATE_FAILURE:
          return state.mergeDeep({
            areCitiesLoading: false,
            form: {
              isSubmitting: false,
              success: false,
              errors: null
            }
          }).setIn(['form', 'errors'], action.error);
    
        case CITY_CREATE_REQUEST:
          return state.mergeDeep({
            areCitiesLoading: true,
            form: {
              isSubmitting: true,
              success: null,
              errors: null
            }
          });
    
        case CITY_CREATE_SUCCESS:
          return state.mergeDeep({
            areCitiesLoading: false,
            form: {
              isSubmitting: false,
              success: true,
              created_id: action.id,
              errors: null
            },
            lastUpdated: action.receivedAt
          });
    
        case CITY_CREATE_FAILURE:
          return state.mergeDeep({
            areCitiesLoading: false,
            form: {
              isSubmitting: false,
              success: false,
              errors: null
            }
          }).setIn(['form', 'errors'], action.error);
    
        case CITY_DELETE_REQUEST:
          return state.mergeDeep({
            areCitiesLoading: true
          });
    
        case CITY_DELETE_SUCCESS:
          return state.mergeDeep({
            areCitiesLoading: false,
            lastUpdated: action.receivedAt
          });
    
        case CITY_DELETE_FAILURE:
          return state.mergeDeep({
            areCitiesLoading: false
          });
    
        case CITY_FORM_DESTROY:
          return state.mergeDeep({
            form: null
          }).set('form', action.form);
          
      default:
        return state;
    }
  }
  
  Logger.log('silly', `city.reducers loaded.`);